import React from 'react';
import HeaderSearchRefreshFilterOptions from "../../shared/components/HeaderSearchRefreshFilterOptions";
import Card from "../../shared/components/Card";
import CardHeader from "../../shared/components/card-header/CardHeader";
import CardBody from "../../shared/components/CardBody";
import {I18nUtils} from "../../../i18n/I18nUtils";
import * as importOutsourcesActions from "../actions/importOutsourceActions";
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import Row from "../../shared/components/Row";
import ImportOutsourceTable from "./ImportOutsourceTable";
import Paginator from "../../shared/components/Paginator";

class ImportOutsourceCard extends React.Component {

  constructor(props){
    super(props);

    this.onSearch = this.onSearch.bind(this);
    this.onPage = this.onPage.bind(this);

    this.state = { search: '', page: 1 }
  }

  componentDidMount(){
    this.getOutsourcesToImport();
  }

  getOutsourcesToImport(){
    this.props.importOutsourcesActions.getOutsources(this.state.page, this.state.search);
  }

  onSearch(search){
    this.setState({ search: search, page: 1 });
  }

  onPage(page){
    this.setState({ page })
  }

  componentDidUpdate( prevProps, prevState ){
    if ( prevState.search !== this.state.search || prevState.page !== this.state.page ){
      this.getOutsourcesToImport();
    }
  }

  renderHeaderOptions(){
    return(
      <HeaderSearchRefreshFilterOptions
        onSearch={this.onSearch}
        enableFilter={false}
        enableRefresh={false}
      />
    );
  }

  render() {
    return (
      <Row>
        <Card colWidth={'col-md-12'} loading={this.props.importOutsourcesLoading}>
          <CardHeader title={I18nUtils.tr('TR_IMPORTAR').toUpperCase()} rightOptions={this.renderHeaderOptions()} />
          <CardBody className={'table-responsive'}>
            <ImportOutsourceTable data={this.props.importOutsources} error={this.props.importOutsourcesError} />
            <Paginator onPage={this.onPage} data={this.props.importOutsourcesPagination}/>
          </CardBody>
        </Card>
      </Row>
    );
  }

}

const mapStateToProps = state => {
  let errorMessage = state.importOutsources.importOutsourcesError;
  if (!errorMessage && state.importOutsources.importOutsources.length === 0 && !state.importOutsources.importOutsourcesLoading){
    errorMessage = I18nUtils.tr('TR_NO_EXISTEN_RESULTADOS');
  }
  return({
    importOutsources: state.importOutsources.importOutsources,
    importOutsourcesLoading: state.importOutsources.importOutsourcesLoading,
    importOutsourcesPagination: state.importOutsources.importOutsourcesPagination,
    importOutsourcesError: errorMessage,
  });
}

const mapDispatchToProps = dispatch => ({
  importOutsourcesActions: bindActionCreators(importOutsourcesActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(ImportOutsourceCard);



// WEBPACK FOOTER //
// ./src/app/outsource/components/ImportOutsourceCard.js